import React from "react";
import { useTranslation } from "react-i18next";

export default function Copyright() {
  const { t } = useTranslation();
  return (
    <>
      <div className="py-4">
        <div className="footer-end-text fs-16 text-white fw-light text-center">
          {t(
            "Copyright © 2025 | All Rights Reserved | Terms and Conditions | Privacy Policy"
          )}
        </div>
      </div>
    </>
  );
}
